'use client'

import { useQuery } from '@tanstack/react-query'
import {
  fetchLandingHeroDemoSrc,
  getLandingHeroFallbackSrc,
  type CmsLandingHeroPageKey,
} from './landing-hero'

/** baby: CMS platform demo URL with hardcoded Blob fallback while loading */
export function useLandingHeroDemoSrc(pageKey: CmsLandingHeroPageKey): string {
  const fallback = getLandingHeroFallbackSrc(pageKey)
  const { data } = useQuery({
    queryKey: ['landing-hero', pageKey],
    queryFn: () => fetchLandingHeroDemoSrc(pageKey),
    staleTime: 60_000,
    placeholderData: fallback,
  })
  return data ?? fallback
}
